import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Icon from '@assets/theme/icons/icons-16-px-star-filled.svg';

export const TYPES = {
  FULL: 'full',
  EMPTY: 'empty',
};

const IconStar = styled(Icon)`
  width: 12px;
  height: 12px;
  fill: ${({ theme, type }) => theme.commons.star[type]};
  margin: ${({ theme }) => theme.spacing(0, 1, 0, 0)};
`;

const Star = ({ type }) => (
  <IconStar viewBox="0 0 16 16" type={type || TYPES.EMPTY} />
);

Star.propTypes = {
  type: PropTypes.string.isRequired,
};

export default Star;
